import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-publish-statement-dialog',
  templateUrl: './publish-statement-dialog.component.html',
  styleUrls: ['./publish-statement-dialog.component.css']
})
export class PublishStatementDialogComponent implements OnInit {
  
  disableConfirmbtn = false;
  api_error: any;
  api_success: string;
  constructor(private formbuilder: UntypedFormBuilder, @Inject( MAT_DIALOG_DATA) public data: any,
   private accountService: AccountService, private dialogRef: MatDialogRef<any>) {}

  ngOnInit() {
    
  }
  publishStatment() {
    this.accountService.publishInvoice(this.data).subscribe(res => {
     this.api_success = 'Invoice Published Successfully';
     setTimeout(() => {
      this.dialogRef.close('reloadlist');
      }, 2000);

    },
     error => {
      this.api_error = error.error;

    });

  }

  

}  
